import { useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import {
  collection, onSnapshot, orderBy, query,
} from 'firebase/firestore'
import { db } from '../../infra/firebase/firebase-app'

import IConversation from '../interfaces/conversation'

const useFetchConversations = (id?: number) => {
  const [conversations, setConversations] = useState<IConversation[]>([])

  useEffect(() => {
    if (id && db) {
      const messagesCollection = collection(db, 'messages')
      const q = query(messagesCollection, orderBy('sendingDate', 'desc'))

      const unsubscribe = onSnapshot(
        q,
        (querySnapshot) => {
          const messagesFetched = querySnapshot.docs
            .map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }))
            .filter((message: any) => {
              const isSender = message.senderId === String(id)
              const isReceiver = message.receiverId === String(id)

              return isSender || isReceiver
            })

          const conversationsMap: Record<string, IConversation> = {}

          messagesFetched.forEach((message: any) => {
            const otherUserId = message.senderId !== String(id)
              ? message.senderId
              : message.receiverId

            if (!conversationsMap[otherUserId]) {
              conversationsMap[otherUserId] = {
                id: otherUserId,
                messages: [],
              }
            }

            conversationsMap[otherUserId].messages.push({
              ...message,
              isReceived: message.senderId !== String(id),
            })
          })

          const conversationsArray: IConversation[] = Object.values(conversationsMap)

          setConversations(conversationsArray)
        },
        (error) => {
          toast.error(`Error fetching messages: ${error.message}`)
        },
      )

      return unsubscribe
    }

    return undefined
  }, [id])

  return conversations
}

export default useFetchConversations
